/* eslint-disable no-control-regex */
/* eslint-disable no-useless-escape */

import escapeStringRegexp from 'escape-string-regexp';
import TurndownService from 'turndown';
import { isNaN, isString, toString } from 'lodash';
import cloneDeep from 'lodash/cloneDeep';
import isObject from 'lodash/isObject';
import queryString from 'query-string';

// const regexDetectATags = /<a[^>]*>.*?<\/a>/g;
const regexDetectATags = /<a href="#[^>]*>.*?<\/a>/g;
const openTagA = /<a/g;
const closeTagA = /<\/a/g;
const href = /href="#/g;

export const isAllNumber = (number = 0) => {
  if (isNaN(Number(number))) {
    return 0;
  }

  return number;
};

export const isASCII = (str) => {
  return /^[\x00-\x7F]*$/.test(str);
};

export const addSuffixToString = (string = '', suffix = '') => {
  return `${string}${suffix}`;
};

export const htmlToMarkdown = (html) => {
  const turndownService = new TurndownService();
  return turndownService.turndown(html);
};

export const isDecimalNumber = (number = 0) => {
  return toString(number).includes('.');
};

export const checkLimitDecimal = (number = 0, limit = 3) => {
  if (isDecimalNumber(number)) {
    if (toString(number).split('.')[1].length <= limit) {
      return true;
    }

    return false;
  }

  return true;
};

export const getIdTargetOnThisPage = (html = '') => {
  // ["#section1", "#section2", ...]
  const listId = (html.match(/href="(#.*?)"/g) || []).map((el) => {
    let tempString = el;
    tempString = tempString.replace(/href="/, '');
    tempString = tempString.replace(/\"/, '');

    return tempString;
  });
  return listId;
};

export const parseContentHTML = (html = '') => {
  if (isString(html)) {
    let tempHtml = html;
    const listDetect = html.match(regexDetectATags);
    if (listDetect) {
      listDetect.forEach((str) => {
        if (new RegExp(escapeStringRegexp(str)).test(tempHtml)) {
          tempHtml = tempHtml.replace(openTagA, '<div');
          tempHtml = tempHtml.replace(closeTagA, '</div');
          tempHtml = tempHtml.replace(href, 'id="');
        }
      });
    }

    return tempHtml;
  }
  return '';
};

export const localeNumber = (number) => {
  if (isNumeric(number)) {
    return Number(number).toLocaleString('en-US', { maximumFractionDigits: 10 });
  }

  return '';
};

export const addCommaToNumber = (number = 0) => {
  if (parseInt(number) >= 1000) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return number;
  }
};

export const capitalizeFirstLetter = (string = '') => {
  if (isString(string)) {
    string = string.toLowerCase();
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  return string;
};

export const handleResponseExport = (data = []) => {
  let csvContent = 'data:text/csv;charset=utf-8,';
  csvContent +=
    'Device id,Online,Default app,Allow display over apps,Allow install unknown app,In used,' +
    'Recent sent,Un sent,Recent delivered,Recent failed,Recent clicked,Account,Group,Phone number,' +
    'Carrier,Os version,Device name,Battery level,Memory (MB),Signal,APK version,Rack,Zip Code,Note,' +
    'Farm,Created';

  const dataWithoutSpecialChar = cloneDeep(data).map((item) => {
    const newItem = { ...item };
    if (isObject(newItem)) {
      Object.keys(newItem).forEach((key) => {
        if (isString(newItem[key])) {
          newItem[key] = newItem[key].replace(/[^a-zA-Z0-9 ]/g, '');
        }
      });
    }

    return newItem;
  });

  dataWithoutSpecialChar.forEach((obj) => {
    let rowCsv = '';
    rowCsv += obj['code'];
    rowCsv += ',';
    rowCsv += obj['online'];
    rowCsv += ',';
    rowCsv += obj['defaultApp'];
    rowCsv += ',';
    rowCsv += obj['displayOverAppsEnabled'];
    rowCsv += ',';
    rowCsv += obj['installUnknownAppEnabled'];
    rowCsv += ',';
    rowCsv += obj['email'] == null;
    rowCsv += ',';
    rowCsv += obj['recentSent'];
    rowCsv += ',';
    rowCsv += obj['unSent'];
    rowCsv += ',';
    rowCsv += obj['recentDelivered'];
    rowCsv += ',';
    rowCsv += obj['recentFailed'];
    rowCsv += ',';
    rowCsv += obj['recentClicked'];
    rowCsv += ',';
    rowCsv += obj['email'];
    rowCsv += ',';
    rowCsv += obj['groupName'];
    rowCsv += ',';
    rowCsv += obj['phoneNumber'];
    rowCsv += ',';
    rowCsv += obj['carrierName'];
    rowCsv += ',';
    rowCsv += obj['osVersion'];
    rowCsv += ',';
    rowCsv += obj['deviceName'];
    rowCsv += ',';
    rowCsv += obj['batteryLevel'];
    rowCsv += ',';
    rowCsv += obj['signalStrength'];
    rowCsv += ',';
    rowCsv += obj['memoryAvailable'] + '/' + obj['memoryCapacity'];
    rowCsv += ',';
    rowCsv += obj['versionCode'];
    rowCsv += ',';
    rowCsv += obj['rackName'];
    rowCsv += ',';
    rowCsv += obj['zipCode'];
    rowCsv += ',';
    rowCsv += obj['note'];
    rowCsv += ',';
    rowCsv += obj['farmName'];
    rowCsv += ',';
    rowCsv += obj['created'];
    csvContent += '\n' + rowCsv.replace(/[\r\n]/g, '');
  });

  let encodedUri = encodeURI(csvContent);
  let link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', 'device_pool_' + new Date().getTime() + '.csv');
  document.body.appendChild(link);

  link.click();
  link.remove();
};

export const isNumeric = (n) => {
  return n !== '' && n !== undefined && n !== null && !isNaN(parseFloat(n)) && isFinite(n);
};

export const uppercaseString = (string = '') => {
  return isString(string) ? string.toUpperCase() : '';
};

export const parseStringToStringCSV = (string) => {
  return isString(string) ? `=\""${string}"\"` : string;
};

export const convertLocaleToNumber = (localeNumber, locale = 'en-US') => {
  //* E.g: localeNumber = '123,456';
  if (isString(localeNumber)) {
    const { format } = new Intl.NumberFormat(locale);
    const [, decimalSign] = /^0(.)1$/.exec(format(0.1));
    return +localeNumber
      .replace(new RegExp(`[^${decimalSign}\\d]`, 'g'), '')
      .replace(decimalSign, '.');
  }

  return null;
};

//* To convert string to number
export const convertValueStringToNumberToCompare = (arg) => {
  if (isString(arg)) {
    if (arg.includes(':')) {
      const nextNumber = Number(arg.replaceAll(':', ''));
      return nextNumber;
    }

    if (arg.includes('%')) {
      return Number(convertLocaleToNumber(arg.replace('%', '')));
    }

    if (arg.includes('$')) {
      return Number(convertLocaleToNumber(arg.replace('$', '')));
    }

    if (isNumeric(arg)) {
      return Number(arg);
    }
  }

  return arg;
};

export function snakeCaseToPascalCase(input) {
  if (typeof input !== 'string') {
    return '';
  }

  return input
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export const genWebsiteLink = (website) => {
  return website.includes('http://') || website.includes('https://') ? website : `//${website}`;
};

export const getQueryStringFromURL = () => {
  return queryString.parse(window.location.search);
};

export const isStrIncludeStr = (str1 = '', str2 = '') => {
  return str1?.toLowerCase().includes(str2?.toLowerCase());
};

export const camelToPascal = (string = '') => {
  if (string === 'fName') return 'First Name';
  if (string === 'lName') return 'Last Name';
  if (string === 'creation_date') return 'Creation Date';
  if (isString(string)) {
    const newString = string[0].toUpperCase() + string.slice(1);
    if (newString.match(/[A-Z][a-z]+/g)) {
      return newString.match(/[A-Z][a-z]+/g).join(' ');
    }
  }
  return '';
};

export function transformLabelToFriendly(string) {
  if (isString(string)) {
    if (string.includes('_')) {
      return snakeCaseToPascalCase(string);
    }

    const firstChar = string[0];
    if (firstChar === string[0].toLowerCase()) {
      return camelToPascal(string);
    }
  }

  return string;
}

export const hasBracketed = (text) => {
  if (!text) return false;
  // Regex pattern: ["any string here"]
  const regex = /\[.*?\]/g;
  return regex.test(text);
};

// Get all matches of format ["string here"]
export const getBracketed = (text) => {
  if (!text) return [];
  const regex = /\[.*?\]/g;
  const matches = [];
  let match;

  while ((match = regex.exec(text)) !== null) {
    matches.push({
      fullMatch: match[0], // Full match: ["string here"]
      content: match[1], // Content inside quotes: string here
      index: match.index, // Position in text
    });
  }

  return matches;
};

export const hasSpintax = (text) => {
  if (!text) return false;
  // Regex pattern: ["any string here"]
  const regex = /\{.*?\}/g;
  return regex.test(text);
};

// Get all matches of format ["string here"]
export const getSpintax = (text) => {
  if (!text) return [];
  const regex = /\{.*?\}/g;
  const matches = [];
  let match;

  while ((match = regex.exec(text)) !== null) {
    matches.push({
      fullMatch: match[0], // Full match: ["string here"]
      content: match[1], // Content inside quotes: string here
      index: match.index, // Position in text
    });
  }

  return matches;
};
